import { type NextPageWithLayout } from '@/pages/_app'
import { GlobalAnimatedHeader } from '@/features/shared/components/Headers/GlobalHeader/GlobalAnimatedHeader'
import { Footer } from '@/features/shared/components/Footers/Footer'
import { ActivityPunchCardFab } from '@/features/shop/components/CategorySubNav/ActivityPunchCardFab'
import { attachLayout } from '@/features/shared/components/Headers/Layouts/attachLayout'

export function withGlobalHeaderLayout<P extends object>(
  Component: NextPageWithLayout<P>,
  {
    suppressFooter,
    excludeSubheader,
    showActivityPunchCardButton,
    isGlobalHomepage,
  }: {
    suppressFooter?: boolean
    excludeSubheader?: boolean
    showActivityPunchCardButton?: boolean
    isGlobalHomepage?: boolean
  } = {},
) {
  return attachLayout(Component, (page) => (
    <>
      <GlobalAnimatedHeader
        excludeSubheader={excludeSubheader}
        isGlobalHomepage={isGlobalHomepage}
      />
      {!!showActivityPunchCardButton && <ActivityPunchCardFab />}
      {page}
      {!suppressFooter && <Footer />}
    </>
  ))
}
